import { TriggerTargetType } from "@/constants/flows";
import { FlowRunDetail } from "@/models/flows";
import { Trigger } from "@radix-ui/react-tabs";
import { MailIcon } from "lucide-react";

interface Props {
  flowRun: FlowRunDetail;
}

export const Manual = ({ flowRun }: Props) => {
  const targetType: TriggerTargetType | undefined = flowRun.trigger.targetType;

  return (
    <div className="ml-9 pb-4">
      {targetType === "individual" && (
        <div>
          <div className="dark:text-white">
            Start from individual{" "}
            <span className="font-semibold">
              {flowRun.triggerInput.firstName} {flowRun.triggerInput.lastName}
            </span>
            .
          </div>
          <div className="flex mt-1 items-center">
            <MailIcon className="h-4 w-4 dark:text-zinc-500 mr-1.5" />
            <p className="dark:text-zinc-500">{flowRun.triggerInput.email}</p>
          </div>
        </div>
      )}
    </div>
  );
};
